import { Injectable } from '@angular/core';

/**
 * The governor that keeps Skipper from becoming the thing people file bugs
 * about: "show nudge X at most once per key per session", enforced in one
 * place instead of an `alreadyShown` flag at every call site.
 *
 * In-memory on purpose: it dies with the tab, so a fresh visit gets the nudge
 * again — which is how people eventually learn a feature exists.
 */
@Injectable({ providedIn: 'root' })
export class SkipperSessionMemory {
  private readonly claimed = new Set<string>();
  private readonly dismissed = new Set<string>();

  /** True the first time `key` is claimed this session (and not dismissed); false ever after. */
  claimOnce(key: string): boolean {
    if (!key || this.dismissed.has(key) || this.claimed.has(key)) return false;
    this.claimed.add(key);
    return true;
  }

  /** The user said "not now" to `key`. Honoured for the rest of the session. */
  dismiss(key: string): void {
    if (key) this.dismissed.add(key);
  }

  /** The one spontaneous hello a session gets. */
  claimGreeting(): boolean {
    return this.claimOnce('greeting');
  }
}
